<template>
    <div>
        <pc-gtm-event-logger 
         :key="1" 
         :eventName="GTMEventName"
         :basketProducts="getGtmEventCheckoutItems || []"
         v-if="getGtmEventCheckoutItems.length"
        />
        <pc-gtm-event-logger 
         :key="2" 
         :eventName="GTMEventName"
         :basketProducts="getGtmEventCheckoutTrayItems || []"
         v-if="getGtmEventCheckoutTrayItems.length"
        />
        <div class="checkout-confirmation-page-container">
            <section class="text-center bg-white main-heading-page">
                <h2>
                    {{ $resourceString["checkout.Title.OrderConfirmation"] }}                    
                </h2>
            </section>
            <div class="container-fluid">
                <div class="row align-items-start">
                    <div class="col-12 col-lg-8 col-xl-9">
                        <div class="checkout-confirmation-page-wrap">

                            <div class="checkout-confirmation-page-details-row checkout-review-details-shipping ">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="primary-heading font-weight-bold checkout-confirmation-order-msg">
                                            {{ $resourceString["checkout.Title.OrderConfirmation.Message"] }}                                             
                                        </h5>
                                    </div>
                                </div>
                            </div>

                            <!-- shipping -->
                            <div class="checkout-confirmation-page-details-row checkout-review-details-shipping">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h5 class="primary-heading font-weight-bold">
                                            {{ $resourceString['checkout.ReviewBasket.Title.OrderSummary'] }}                                            
                                        </h5>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5 col-sm-6 col-12">
                                        <div class="checkout-review-details-col">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.Shipping.Label.ShipTo"] }}:</p>
                                            </div>
                                            <div class="details-body">                                               
                                                <div class="details-body-shipping-address" >
                                                    <span>{{ currentAddress.firstName }} {{ currentAddress.lastName }}</span>
                                                    <span>{{ currentAddress.suite ? `${currentAddress.addressLine1}, Suite ${currentAddress.suite}` : currentAddress.addressLine1 }}.</span>
                                                    <span>{{ currentAddress.city }}, {{ currentAddress.state }}, {{ currentAddress.postalCode }}, {{ currentAddress.country }}.</span>                                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7 col-sm-6 col-12" v-if="shippingOption">
                                        <div
                                            class="checkout-review-details-col checkout-review-shipping-option-details">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.Shipping.Label.ShippingOptions"] }}:</p>
                                            </div>
                                            <div class="details-body">
                                                <div class="checkout-review-shipping-options-list">
                                                    <span>{{ getShippingOptionName(shippingOption).title || 'N/A' }}</span>
                                                     <span>{{ getShippingOptionName(shippingOption).description || 'N/A'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Project Information -->
                            <div class="checkout-confirmation-page-details-row checkout-review-details-shipping">                                
                                <div class="row">
                                    <div class="col-12">
                                        <div class="checkout-review-details-col">
                                            <div class="details-label-heading">
                                                <p>{{ $resourceString["checkout.ProjectInformation.Label.ProjectName"]}}:</p>
                                            </div>
                                            <div class="details-body">
                                                <div class="details-body-shipping-address">
                                                    <span>{{ projectInfo.projectName || 'N/A'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Product sample list -->
                            <div class="checkout-confirmation-page-details-row checkout-review-details-shipping">
                                <div v-for="list in Object.keys(checkoutItemList)" :key="list" v-if="checkoutItemList[list].length > 0">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h5 class="primary-heading font-weight-bold">                                          
                                                 <span v-if="list.toLowerCase() === siteItems.toLowerCase()">{{ $resourceString['myBasket.Label.IndividualSamples'] }} : {{ checkoutItemCount.siteItems }}</span>
                                                 <span v-if="list.toLowerCase() === projectItems.toLowerCase()">{{ $resourceString['myBasket.Label.ProjectSamples'] }} : {{ checkoutItemCount.projectItems }}</span>
                                                 <span v-if="list.toLowerCase() === trayItems.toLowerCase()">{{ $resourceString['myBasket.Label.DesignTraySample'] }} : {{ checkoutItemCount.trayItems }}</span>                                               
                                            </h5>
                                        </div>
                                    </div> 
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="checkout-review-details-col">
                                                <basket-item 
                                                :listItems="checkoutItemList[list]" 
                                                :listName="list.toLowerCase() === siteItems.toLowerCase() 
                                                            ? siteItems : list.toLowerCase() === projectItems.toLowerCase() 
                                                            ? projectItems : list.toLowerCase() === trayItems.toLowerCase() 
                                                            ? trayItems : ''"
                                                :isCheckoutPage="true"
                                                :isClearAll="false"
                                                />
                                            </div>
                                        </div>                                  
                                    </div>                                  
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device">
                        <div class="checkout-basket-sidebar-warpper">
                            <div class="checkout-basket-sidebar-container">                               
                                <pc-basket-sidebar 
                                    :confirmationPage="true"
                                    :nextLabel="(isTrayAvailable || isCartAvailable || isProjectAvailable) ? $resourceString['myBasket.Button.GoToMyBasket'] : ''"
                                    :nextAction="(isTrayAvailable || isCartAvailable || isProjectAvailable) ? goToMyBasketHandler : ''"
                                    :exploreButtonOneLabel="$resourceString['orderConfirmation.RightSideBar.FirstButton.Label']"
                                    :exploreButtonOneAction="exploreButtonOneAction"
                                    :exploreButtonTwoLabel="$resourceString['orderConfirmation.RightSideBar.SecondButton.Label']"
                                    :exploreButtonTwoAction="exploreButtonTwoAction"
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>

import pcBasketSidebar from "../new-basket-page/pc-basket-sidebar.vue";
import BasketItem from "../new-basket-page/pc-basket-list.vue";
import { BASKET_SITEITEMS, BASKET_PROJECTITEMS, BASKET_TRAYITEMS } from "../../../constants/checkout-constant";
import { TRANSACTION_EVENT_NAME } from "../../../constants/gtm-constants";
import PCGTMEventLogger from "../pc-gtm-event-logger.vue";
export default {
    props: ["checkoutdatamodel"],
    data() {
        return {
            currentAddress: {},
            shippingOption: "",
            projectInfo: {},
            purchasedProducts : [],
            checkoutItemList: {
                siteItems: [],
                projectItems: [],
                trayItems: [],
            },
            checkoutItemCount: {
                siteItems: 0,
                projectItems: 0,
                trayItems: 0 
            },
            isTrayAvailable: null,
            isCartAvailable: null,
            isProjectAvailable: null,
            siteItems: BASKET_SITEITEMS,
            projectItems: BASKET_PROJECTITEMS,
            trayItems: BASKET_TRAYITEMS,
            GTMEventName: TRANSACTION_EVENT_NAME,
        }
    },
    components: {
        pcBasketSidebar,
        BasketItem,
        "pc-gtm-event-logger": PCGTMEventLogger,
    } ,
    computed:{
        getGtmEventCheckoutItems() {
            const data = this.checkoutdatamodel;
            const firstElement =  data[0] || {}
            // gtm event data
            const getGtmEventCheckoutItems1 = [];
            const cartItems = [... this.checkoutItemList.siteItems, ...this.checkoutItemList.projectItems]
            if(cartItems.length > 0) {
                getGtmEventCheckoutItems1.push({
                    ...firstElement,
                    Items: cartItems
                })
            }
            return getGtmEventCheckoutItems1;
        },
        getGtmEventCheckoutTrayItems() {
            const data = this.checkoutdatamodel;
            const secondElement =  data[1] || {}
            // gtm event data
            const getGtmEventCheckoutItems1 = [];
            if(this.checkoutItemList.trayItems.length > 0) {
                getGtmEventCheckoutItems1.push({
                    ...secondElement,
                    Items: this.checkoutItemList.trayItems
                })
            }
            return getGtmEventCheckoutItems1;
        },
    },
    methods: {
        goToMyBasketHandler() {
            let url = new URL(window.location);
            window.location.href = url.origin + "/Basket";
        },
        exploreButtonOneAction() {
            try {
                new URL(this.$resourceString['orderConfirmation.RightSideBar.FirstButton.Url']);
                window.location.href = this.$resourceString['orderConfirmation.RightSideBar.FirstButton.Url'];
            } catch (e) {
                console.log(e)
            }
        },
        exploreButtonTwoAction() {
            try {
                new URL(this.$resourceString['orderConfirmation.RightSideBar.SecondButton.Url']);
                window.location.href = this.$resourceString['orderConfirmation.RightSideBar.SecondButton.Url'];
            } catch (e) {
                console.log(e)
            }
        },
        getShippingOptionName(value) {
            const shippingOptionName = {
                standard: {
                    title: this.$resourceString["checkout.Shipping.Standard"],
                    description: this.$resourceString["checkout.Shipping.Standard.Description"]
                },
                secondday: {
                    title: this.$resourceString["checkout.Shipping.SecondDay"],
                    description: this.$resourceString["checkout.Shipping.SecondDay.Description"]
                },
                ground: {
                    title: this.$resourceString["checkout.Shipping.Ground"],
                    description: this.$resourceString["checkout.Shipping.Ground.Description"]
                },
                sameday: {
                    title: this.$resourceString["checkout.Shipping.SameDay"],
                    description: this.$resourceString["checkout.Shipping.SameDay.Description"]
                },
                localpickup: {
                    title: this.$resourceString["checkout.Shipping.LocalPickup"],
                    description: this.$resourceString["checkout.Shipping.LocalPickup.Description"]
                },
            }
            if(value) {
                return shippingOptionName[value.toLowerCase()] || {}
            } 
            return {}
        },

        scrollMethod() {
            let currentScroll = (document.documentElement.scrollTop || document.body.scrollTop);
            const element = document.querySelector(".sidebar-mobile-device");
            if(element) {
                const divTop = element.getBoundingClientRect().top + window.scrollY;
                const windowHeight = window.innerHeight;
                const result = divTop - windowHeight;
                if(currentScroll >= result) {
                    element.classList.remove("__sticky")
                } else {
                    element.classList.add("__sticky")               
                }
            }            
        } 
    },
    mounted() {        
        if(this.checkoutdatamodel.length > 0) {
            const data = this.checkoutdatamodel;
            const firstElement =  data[0] || {}
            this.shippingOption = firstElement.ShippingOption;
            this.currentAddress = {
                firstName: firstElement.FirstName,
                lastName: firstElement.LastName,
                addressLine1: firstElement.AddressLine1,
                city: firstElement.City,
                state: firstElement.State,
                postalCode: firstElement.PostalCode,
                country: firstElement.Country,
                suite: firstElement.Suite
            };
            this.projectInfo = {
                projectComments: firstElement.ProjectComments,
                projectName: firstElement.ProjectName
            };

            data.forEach(element => {               
                const siteItems = [];
                const projectItems = [];
                const trayItems = [];
                element.Items.forEach((item) => {
                    if (item.Item.IsTrayItem) {
                        this.checkoutItemCount.trayItems += item.Quantity || 0
                        trayItems.push(item);
                    } else if(item.Item.IsProjectItem) {
                        this.checkoutItemCount.projectItems += item.Quantity || 0
                        projectItems.push(item);
                    } else {
                        this.checkoutItemCount.siteItems += item.Quantity || 0
                        siteItems.push(item);
                    }
                });
                if(siteItems.length > 0) {
                    this.checkoutItemList.siteItems.push(...siteItems);
                };
                if(projectItems.length > 0) {
                    this.checkoutItemList.projectItems.push(...projectItems);
                }
                if(trayItems.length > 0) {
                    this.checkoutItemList.trayItems.push(...trayItems);
                }
            });

            this.isTrayAvailable = this.$cookies.get("traycart");
            this.isCartAvailable = this.$cookies.get("cart");
            this.isProjectAvailable = this.$cookies.get("projectcart");
            this.$cookies.remove("OrderAddresses");
            this.$cookies.remove("ideaBook");            
        } 
        
        // sidebaar sticky for bottom
        window.addEventListener("scroll", this.scrollMethod);
        this.resizeObserver = new ResizeObserver(() => this.scrollMethod())
        this.resizeObserver.observe(document.body);
    },
    destroyed(){
        window.removeEventListener("scroll", this.scrollMethod);
        this.resizeObserver.disconnect();
    },
}
</script>